if (!process.env.VUE_APP_IS_WEB) {
  var BuildingDB = require("../database/models/Building");
}
import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import BuildingORM from "@/store/orm-axios/models/Building";

export default {
  QUERY_FETCH_PROPERTIES(agencyId, properties) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: !!!: for nested properties case
      return new Promise((resolve, reject) => {
        new BuildingDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll({
            columns: properties,
          })
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .QUERY_FETCH_PROPERTIES(agencyId, properties)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll()
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams) {
    console.log(queryParams);
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .query(qb => {
            queryParams.filter.forEach(filter => {
              qb.where(filter.column, "LIKE", "%" + filter.value + "%");
            });
          })
          .orderBy(queryParams.sort.by, queryParams.sort.dir)
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
            withRelated: [
              {
                building_owners: query => {
                  query.where("deleted", null);
                },
              },
              {
                building_lots: query => {
                  query.where("deleted", null);
                },
              },
              // NOTE: to check if building has meetings (when delete)
              {
                meetings: query => {
                  query.select("id", "building_id").where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH_WITH_PROPERTIES_AND_PAGINATION(agencyId, queryParams, properties) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: !!!: for nested properties case
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .QUERY_FETCH_WITH_PROPERTIES_AND_PAGINATION(agencyId, queryParams, properties)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_BY_PAGE(agencyId, queryParams, properties, pagination) {
    queryParams.page = pagination.page;
    queryParams.pageSize = pagination.pageSize;
    queryParams.itemsPerPage = pagination.pageSize;
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        //  TODO: Implement functionality
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .QUERY_FETCH_WITH_PROPERTIES_AND_PAGINATION(agencyId, queryParams, properties)
          .then(res => {
            BuildingORM.deleteAll();
            BuildingORM.insertOrUpdate({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingDB({ id: id, deleted: null })
          .fetch({
            withRelated: [
              {
                building_owners: query => {
                  query.where("deleted", null);
                },
              },
              {
                building_lots: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            // console.log(res.serialize());
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new BuildingDB(itemPost)
          .save()
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new BuildingDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new BuildingDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            BuildingORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CUSTOM_DELETE(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .CUSTOM_DELETE(id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER_GET_BUILDING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .REGISTER_GET_BUILDING(meetingId)
          .then(res => {
            BuildingORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  BUILDINGS_LIST() {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        BuildingORM.api()
          .BUILDINGS_LIST()
          .then(res => {
            BuildingORM.insertOrUpdate({
              data: res.response.data["hydra:member"],
            });
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
